<template>
  <h1 class="d-none">Welcome to India GPT</h1>
  <SearchForGuest></SearchForGuest>
  <section class="hero_slider" ref="section1" id="home">
    <div class="container">
      <div class="row align-items-center justify-content-center vh-100">

        <div class="col-md-6">
          <span class="label_box mb-2" data-aos="fade-up" data-aos-delay="10">{{ $t('text_engage_explore_evolve')
            }}</span>
          <h3 class="sub-headline-decor mt-3" data-aos="fade-up" data-aos-delay="50">
            {{ $t('text_unlock_limitless_conversations') }}
          </h3>
          <h1 data-aos="fade-up" data-aos-delay="100">
            <span v-html="$t('title')" class="headline-decor fw-bolder"></span>
          </h1>
          <div class="d-flex gap-2 mt-5 justify-content-center justify-content-md-start" data-aos="fade-up"
            data-aos-delay="200" v-if="!$store.getters.isAuthenticated">
            <router-link class="button button_dark" :to="{ name: 'RegisterView' }">{{ $t('menu_register')
              }}</router-link>
            <router-link class="button button_light" :to="{ name: 'LoginView' }">{{ $t('menu_login') }}</router-link>
          </div>
        </div>
        <div class="col-6 col-md-6">
          <img src="../../assets/hand.png" class="full_image">
          <img src="../../assets/hand-ltr.png" class="full_image_ltr">
        </div>
      </div>
    </div>
  </section>

  <!-- about -->
  <section id="about" ref="section2" class="py-5">
    <div class="container">
      <div class="row align-items-center justify-content-center my-5">
        <div class="col-md-12 mt-5" data-aos="fade-down">
          <h3 class="sub-headline-decor-small">{{ $t('text_about_us') }}</h3>
          <div class="row">
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <h4 class="sub-headline-decor">{{ $t('text_our_journey_began_with_a_simple_idea') }}</h4>
                </div>
                <div class="flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 91 91" fill="none">
                    <g clip-path="url(#clip0_817_22135)">
                      <path
                        d="M30.9126 14.0716C34.3213 9.76431 40.7406 7.63718 45.1162 7.52723C57.386 7.29214 62.501 22.7432 62.8953 28.8857L68.5753 30.6071C67.2671 11.7777 55.6836 1.90039 44.6005 1.90039C34.2076 1.8966 24.6109 9.53302 20.7434 20.7298C15.4616 35.6576 18.9272 50.0091 25.4033 61.494C24.8384 62.241 24.4971 63.5567 24.6109 64.8193C24.7208 68.2659 27.6177 71.1362 31.087 71.1362H31.3145C32.173 71.1116 33.0178 70.9156 33.7993 70.5598C34.5809 70.2039 35.2834 69.6954 35.8656 69.0641C36.4478 68.4328 36.8979 67.6915 37.1894 66.8838C37.481 66.076 37.608 65.2181 37.5632 64.3605C37.5632 60.9139 34.6095 58.0512 31.1439 58.0512H30.9126C30.6851 58.0512 30.3477 58.0512 30.0595 58.1611C25.3465 50.1228 23.3558 41.5081 24.099 32.2148C24.5502 25.2078 26.8252 19.1221 30.9126 14.0716Z"
                        fill="url(#paint0_linear_817_22135)" />
                      <path
                        d="M3.53245 79.2372C7.33929 84.9778 15.1236 88.6481 23.6435 88.6481C25.9147 88.6481 28.3034 88.4813 30.6315 87.905C45.4038 85.0347 56.5968 76.0788 63.0161 62.8762L63.0692 62.7586C66.3642 62.4705 68.9197 59.5395 68.7529 56.036C68.5785 52.5325 65.7385 49.7229 62.2767 49.7229H62.0455C58.4699 49.8404 55.683 52.8814 55.7968 56.5024C55.9105 58.3376 56.6537 59.8315 57.6699 60.9197C53.6962 68.7305 47.7319 74.4673 38.6964 79.2941C32.6183 82.5056 26.199 83.7152 19.9504 82.8545C14.7255 82.1113 10.638 79.7491 8.13554 75.965C4.38937 70.2206 4.04812 64.0251 7.16866 57.8257C9.44745 53.3477 12.8524 50.0755 15.1274 48.4641C14.5586 46.9739 13.8761 44.4487 13.5349 42.5566C-3.28875 54.7241 -1.57871 71.3695 3.53245 79.2372Z"
                        fill="url(#paint1_linear_817_22135)" />
                      <path
                        d="M88.9738 76.7055C92.3787 69.816 92.0981 58.2211 83.4038 48.287L83.3507 48.4007C74.5503 37.9509 61.5941 32.2103 46.818 32.2103H44.8843C43.925 30.087 41.7106 28.7637 39.2081 28.7637H39.0375C35.462 28.7637 32.6751 31.869 32.7926 35.4825C32.9064 38.9253 35.8032 41.7994 39.2688 41.7994H39.5494C40.7824 41.7468 41.9741 41.3396 42.9816 40.6267C43.989 39.9139 44.7695 38.9255 45.2293 37.7803H47.3337C56.0886 37.7803 64.3772 40.3624 71.9378 45.4129C77.7277 49.2614 81.8796 54.3119 84.2076 60.3407C86.2476 65.2774 86.1376 70.1004 84.037 74.1234C80.7989 80.4365 75.3427 83.7694 68.131 83.7694C63.5848 83.7694 59.1561 82.3323 56.8811 81.301C55.5199 82.4423 53.2449 84.3381 51.5955 85.4908C56.5929 87.781 61.651 89.1043 66.5347 89.1043C77.6139 89.1043 85.8456 82.7949 88.9738 76.7055Z"
                        fill="url(#paint2_linear_817_22135)" />
                    </g>
                    <defs>

                      <linearGradient id="paint0_linear_817_22135" x1="43.3697" y1="1.90039" x2="43.3697" y2="71.1362"
                        gradientUnits="userSpaceOnUse">
                        <stop offset="0.012687" stop-color="#3FC33A" />
                        <stop offset="0.796446" stop-color="#D48208" />
                      </linearGradient>
                      <linearGradient id="paint1_linear_817_22135" x1="12.5" y1="63.5" x2="65" y2="60"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="var(--template-color-15)" />
                        <stop offset="1" stop-color="#45C138" />
                      </linearGradient>
                      <linearGradient id="paint2_linear_817_22135" x1="61.8946" y1="28.7637" x2="61.8946" y2="89.1043"
                        gradientUnits="userSpaceOnUse">
                        <stop offset="0.086817" stop-color="#3BC53B" />
                        <stop offset="0.592871" stop-color="#D38207" />
                      </linearGradient>
                      <clipPath id="clip0_817_22135">
                        <rect width="91" height="91" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <p class="description mt-3" v-html="$t('text_home_page_about_desc')"></p>

        </div>
        <div class="learnmore nav-item mb-2">
          <router-link :to="{ name: 'AboutUsPage' }" class="d-flex nav-link p-0">
            <p v-html="$t('learmore')"> </p> <i class="bi bi-arrow-right"></i>
          </router-link>
        </div>

      </div>
    </div>
  </section>
  <section class="py-5 get_started" ref="section3" data-aos="fade-down">
    <div class="container py-5">
      <div class="row align-items-center justify-content-center ">
        <div class="col-md-6 order-1 order-md-1" data-aos="fade-down" data-aos-delay="500">
          <img src="../../assets/map.svg" class="w-100" alt=map loading="lazy">
        </div>
        <div class="col-md-6 order-2 order-md-2" data-aos="fade-down" data-aos-delay="1000">
          <h4 class="sub-headline-decor text-black fw-bolder "><span v-html="$t('headline_get_started')"></span></h4>
          <h4 class="sub-headline-decor_two description fw-bolder "><span v-html="$t('sub-headline-decor_two')"></span>
          </h4>
          <div v-html="$t('description_privacy_policy')"></div>
        </div>
      </div>
    </div>
  </section>

  <!-- How to Get Started Using India GPT is simple our-vision and vision-->

  <section id="our_vision" ref="section3" data-aos="fade-down">
    <div class="container py-5">
      <div class="row align-items-center justify-content-center ">
        <div class="homeImageHand col-md-6 order-md-2" data-aos="fade-down" data-aos-delay="500">
          <img src="../../assets/hand-2.png" class="w-100">
        </div>
        <div class="col-md-6 order-md-1" data-aos="fade-down" data-aos-delay="1000">
          <h4 class="sub-headline-decor fw-bolder text-white" v-html="$t('headline_our_vision')"></h4>
          <p class="description mt-3 text-light">
            {{ $t('description_our_vision') }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <section id="our_vision" ref="section3" data-aos="fade-down">
    <div class="container py-5">
      <div class="row align-items-center justify-content-center ">
        <div class="homeImageHand col-md-6 order-md-1" data-aos="fade-down" data-aos-delay="1000">
          <img style="transform: scaleX(-1)" src="../../assets/hand-2.png" class="w-100">

        </div>
        <div class="col-md-6 order-md-2" style="text-align: start;" data-aos="fade-down" data-aos-delay="500">
          <h4 class="sub-headline-decor fw-bolder text-white" v-html="$t('headline_our_misson')"></h4>
          <p class="description mt-3 text-light">
            {{ $t('description_our_mission') }}
          </p>
        </div>
      </div>
    </div>
  </section>
  <section id="our-vision" data-aos="fade-down" data-aos-delay="500">
    <div class="container py-5">
      <div class="row align-items-center justify-content-center py-5">
        <div class="col-12">
          <h4 class="sub-headline-decor text-black fw-bolder text-center mb-0 mb-md-5 pb-md-5">
            {{ $t('headline_our_values') }}</h4><br><br>
          <div class="row g-4">
            <div class="col-12 col-md-6 col-lg-3">
              <div class="card custom_card text-center border-0 h-100">
                <div class="card-header border-0 bg-transparent"><img class="image-top- w-50"
                    src="../../assets/Innovation.webp" width="img-fluid" alt="innovation" loading="lazy"></div>
                <div class="card-body border-0">
                  <h4 class="sub-headline-decor-small text-white">{{ $t('sub_headline_our_values_innovation') }}</h4>
                  <p class="description text-white">
                    {{ $t('description_our_values_innovation') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="card custom_card text-center border-0 h-100">
                <div class="card-header border-0 bg-transparent"><img class="image-top- w-50"
                    src="../../assets/Ethics.webp" width="img-fluid" alt="Ethics" loading="lazy"></div>
                <div class="card-body border-0">
                  <h4 class="sub-headline-decor-small text-white">{{ $t('sub_headline_our_values_ethics') }}</h4>
                  <p class="description text-white">
                    {{ $t('description_our_values_ethics') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="card custom_card text-center border-0 h-100">
                <div class="card-header border-0 bg-transparent"><img class="image-top- w-50"
                    src="../../assets/Accessibility.webp" width="img-fluid" alt="Accessibility"></div>
                <div class="card-body border-0">
                  <h4 class="sub-headline-decor-small text-white">{{ $t('sub_headline_our_values_accessibility') }}</h4>
                  <p class="description text-white">
                    {{ $t('description_our_values_accessibility') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="card custom_card text-center border-0 h-100">
                <div class="card-header border-0 bg-transparent"><img class="image-top- w-50"
                    src="../../assets/Continuous-Learning.webp" width="img-fluid" alt="Continous Learning"></div>
                <div class="card-body border-0">
                  <h4 class="sub-headline-decor-small text-white">{{ $t('sub_headline_our_values_continuous_learning')
                    }}
                  </h4>
                  <p class="description text-white">
                    {{ $t('description_our_values_continuous_learning') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="get_started py-5">
    <div class="container py-5" data-aos="fade-down" data-aos-delay="500">
      <div class="row align-items-center justify-content-center">
        <div class="col-12">
          <h4 class="sub-headline-decor text-black fw-bolder text-center mb-5">{{ $t('headline_what_sets_us_apart') }}
          </h4>
          <p class="description text-center">
            {{ $t('description_what_sets_us_apart')}}
          </p>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-5">
      <img style="width: 100%; height: auto;" class="" src="../../assets/bg-section-4.webp" alt="bg section 4">
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { useHead } from "@vueuse/head";
import SearchForGuest from "@/components/SearchForGuest.vue"

export default {
  name: 'HomeView',
  setup() {
    useHead({
      title: 'Welcome to India GPT'
    })
  },
  components: {
    SearchForGuest
  }
}
</script>

<style>
.learnmore {
  color: var(--template-color-15);
  font-family: Outfit;
  font-size: 28px;
}
</style>